import { useApp } from 'contexts/app';
import { useViewport } from 'contexts/viewport';
import { PageContext } from 'pages/InstructorFormativeJourney/PageProvider';
import { useContext } from 'react';
import { Paper, Stack, styled, Text } from 'shell/components';
import { getUserPreferredFullName } from 'utils/helper';

const FormativeJourneySummaryCard = () => {
    const { studentAccountUsers } = useApp();
    const { device } = useViewport();

    const { currentStudentSubmissions } = useContext(PageContext);

    const latestStudentSubmission = currentStudentSubmissions.slice(-1)[0];

    return (
        <CustomPaper device={device}>
            <Stack spacing={3}>
                <Text weight={'medium'}>
                    {getUserPreferredFullName(
                        studentAccountUsers.find(
                            ({ owner_account_id }) => owner_account_id === latestStudentSubmission.owner_account_id
                        )
                    )}
                    ’s Learning Process 📌
                </Text>
                <Text>{latestStudentSubmission.ai.ai_learning_summary}</Text>
            </Stack>
        </CustomPaper>
    );
};

const CustomPaper = styled(Paper)(({ theme, device }) => {
    return {
        maxWidth: '500px',
        height: 'fit-content',
        padding: theme.spacing(3),
        ...(device !== 'mobile' && {
            alignSelf: 'end',
        }),
    };
});

export default FormativeJourneySummaryCard;
